module.exports = __webpack_public_path__ + "static/media/marker_red.37db23b6.svg";